var map = {
	"./icons/telegram.svg": "14ac",
	"./wallet/ui/arrow.svg": "4860",
	"./wallet/ui/close-black.svg": "12ad",
	"./wallet/ui/close.svg": "531b",
	"./wallet/ui/down-left-white.svg": "b460",
	"./wallet/ui/down-left.svg": "bfee",
	"./wallet/ui/menu.svg": "c063",
	"./wallet/ui/refresh.svg": "5ee1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";